export default "__VITE_ASSET__CZCojrHo__"